import { CUSTOMER_JOURNEY_SERVICES_BOOK_ERROR } from './../const';

function action(errorCallback) {
  return { type: CUSTOMER_JOURNEY_SERVICES_BOOK_ERROR, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyServicesBookError.js